/**
 * Por qué no se pudo leer el resumen global (feature 108). La pantalla elige con la
 * CLASE qué copy traducido pinta; ninguna transporta texto del backend.
 *
 * Clases puras (sin Angular): el data source traduce el status HTTP y el resto de
 * fallos (red, 5xx, tiempo agotado) viaja tal cual y la pantalla ofrece reintento.
 */

/** 403: el usuario no tiene acceso al resumen. No se ofrece reintentar. */
export class GlobalDashboardForbiddenError extends Error {
  constructor() {
    super('GLOBAL_DASHBOARD_FORBIDDEN');
    this.name = 'GlobalDashboardForbiddenError';
  }
}

/** 404: el endpoint todavía no está desplegado. No se ofrece reintentar. */
export class GlobalDashboardUnavailableError extends Error {
  constructor() {
    super('GLOBAL_DASHBOARD_UNAVAILABLE');
    this.name = 'GlobalDashboardUnavailableError';
  }
}
